<template>
  <div role="alert" aria-live="assertive" aria-atomic="true" class="toast toast-error position-fixed" id="error-toast"
    data-bs-autohide="false">
    <div class="toast-header border-0 rounded bg-danger text-white flex-1">
      <span class="fas fa-exclamation-circle"></span>
      <strong class="me-auto ms-2">{{ msg }}</strong>
      <button type="button" class="btn-close text-white" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";
import { Toast } from "bootstrap";
import { EventBus, EventBusNames } from "@/utils/EventBus";

const msg = ref("");
const toast = () => new Toast(document.getElementById("error-toast")!);

const hideToast = () => {
  toast().hide();
};
function handleToast(data: { msg?: string }) {
  msg.value = data.msg ?? "";
  toast().show();
  setTimeout(hideToast, 6000);
}

onMounted(() => {
  EventBus.$on(EventBusNames.SHOW_ERROR_TOAST, handleToast);
});
onBeforeUnmount(() => {
  EventBus.$off(EventBusNames.SHOW_ERROR_TOAST, handleToast);
});
</script>
<style scoped>
.toast-error {
  z-index: 99999999;
  top: 60px;
  left: calc(50% - 150px);
}

.toast-error.show {
  display: flex;
}
</style>
